import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@element-plus/icons-vue'
import 'normalize.css'
import 'uno.css'
import 'material-symbols/outlined.css'
import './styles/element-theme.scss'
import './styles/index.scss'
import { setupPermissionDirective } from './plugins/permission-directive'
import { setupProtectMedia } from './plugins/protect-media'
import { resolveResourceUrl } from '@/common/config'
import i18n from './locales'
import { useLocaleStore } from './pinia/stores/locale'
import { useSettingsStore } from './pinia/stores/settings'
import { setupChunkErrorReload, setupVersionCheck } from './utils/version-check'

const app = createApp(App)
app.config.globalProperties.resolveResourceUrl = resolveResourceUrl

// 注册插件
app.use(pinia)
app.use(router)
app.use(i18n)

// 发版后旧前端静默刷新（不提示用户）
setupChunkErrorReload(router)
setupVersionCheck()

// 启动时同步夜间模式到 html（避免闪白）
const settingsStore = useSettingsStore()
const html = document.documentElement
if (settingsStore.theme === 'dark') {
  html.classList.add('dark')
  html.setAttribute('data-kp-theme', 'dark')
} else {
  html.classList.remove('dark')
  html.setAttribute('data-kp-theme', 'light')
}

// Element Plus 使用 locale store 中的动态语言包
const localeStore = useLocaleStore()
app.use(ElementPlus, { locale: localeStore.elmLocale })

// 注册权限指令
setupPermissionDirective(app)

// 素材/媒体预览：禁右键另存、隐藏播放器下载控件（前端级）
setupProtectMedia()

app.mount('#app')

